<button
  class="{{ type() }} color-{{ color() }} density-{{ density() }}"
  [disabled]="disabled()">
  <ng-content></ng-content>
</button>
